import { useStore } from "../store/hooks/use-store";
import { useParams } from "react-router";
import { GenericNotFoundPageLayout } from "../layouts/generic-not-found/GenericNotFoundPageLayout";
import React from "react";
import { LocalizedFallbackRoute } from "./localized-fallback-route";
import { ModalLoadingSpinner } from "./modal-loading-spinner";
import { useFetchedConstant } from "../hooks";
import { storefrontClient } from "../domain/storefront";
import { AppView } from "../styles/AppView";
import { getIsoCodeWithIntFallback } from "@swo/shared";

export function FallbackRoute() {
  const store = useStore();
  const params = useParams<{ countryIsoCode: string | undefined; languageIsoCode: string | undefined }>();
  const locales = useFetchedConstant(() => storefrontClient.getLocales());

  if (locales.__tag !== "loaded") {
    return <ModalLoadingSpinner />;
  }

  const maybeParamLocale = locales.data.locales.find(
    locale =>
      getIsoCodeWithIntFallback(locale.country) === params.countryIsoCode &&
      locale.language.isoCode === params.languageIsoCode,
  );

  const userPreferredLocale = store.state.userPreferredLocale
    ? locales.data.locales.find(locale => locale.code === store.state.userPreferredLocale)
    : undefined;

  const countryBasedLocale =
    params.countryIsoCode && !params.languageIsoCode
      ? locales.data.locales.find(locale => getIsoCodeWithIntFallback(locale.country) === params.countryIsoCode)
      : undefined;

  const maybeLocale = maybeParamLocale || userPreferredLocale || countryBasedLocale;

  if (maybeLocale) {
    return (
      <AppView>
        <LocalizedFallbackRoute locale={maybeLocale} notFoundPageTranslations={fallbackNotFoundTranslations} />
      </AppView>
    );
  } else {
    return (
      <AppView>
        <GenericNotFoundPageLayout translations={fallbackNotFoundTranslations} />
      </AppView>
    );
  }
}

export const fallbackNotFoundTranslations = {
  "notFound.headline": "Not found",
  "notFound.paragraph": "Page not found.",
  "notFound.goBackButtonLabel": "Go back",
};
